import { NgModule } from '@angular/core';

import { MenuItems } from '../layouts/full/menu-items';
import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective
} from './directives/accordion';
import { EnumKeyValuePipe } from './pipes/enum-key-value.pipe';
import { PrettyJsonPipe } from './pipes/pretty-json.pipe';
import { EncodeHtmlPipe } from './pipes/encodeHtml.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { AuthPipe } from './pipes/auth.pipe';
import { RouteReuseStrategy } from '@angular/router';
import { httpInterceptorProviders } from './interceptors';
import { ReuseStrategy } from './routing/reuse-strategy';
import { IFrameResizerDirective } from './directives/iframe-resizer.directive';
import { ColumnResizeDirective } from './directives/column-resize.directive';
import { NumericFieldDirective } from './numeric-expression/numeric-field.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthGuard } from './guards/auth.guard';
import { MaterialModule } from '../material.module';
import { CoreModule, FlexLayoutModule } from '@angular/flex-layout';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { ChartsModule } from 'ng2-charts';
import { HttpClientModule } from '@angular/common/http';
import { ChartComponent } from '../components';
import { HighlightSearchPipe } from './pipes/highlight-search.pipe';
import { ReplacePipe } from './pipes/replace.pipe';
import { ArrayCountPipe } from './pipes/array-count.pipe';
import { SituFurnishMenuComponent } from './components/situ-furnish-menu/situ-furnish-menu.component';
import { SituFurnishMenuDialogComponent } from './components/situ-furnish-menu-dialog/situ-furnish-menu-dialog.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true
};

@NgModule({
  imports: [
    ChartsModule,
    PerfectScrollbarModule,
    CoreModule,
    FormsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ChartComponent,
    IFrameResizerDirective,
    ColumnResizeDirective,
    NumericFieldDirective,
    EnumKeyValuePipe,
    PrettyJsonPipe,
    EncodeHtmlPipe,
    SafePipe,
    AuthPipe,
    HighlightSearchPipe,
    ReplacePipe,
    ArrayCountPipe,
    SituFurnishMenuComponent,
    SituFurnishMenuDialogComponent,
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    EnumKeyValuePipe,
    PrettyJsonPipe,
    ChartComponent,
    IFrameResizerDirective,
    ColumnResizeDirective,
    NumericFieldDirective,
    ChartsModule,
    PerfectScrollbarModule,
    EncodeHtmlPipe,
    SafePipe,
    AuthPipe,
    HighlightSearchPipe,
    CoreModule,
    FormsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
    ReplacePipe,
    ArrayCountPipe,
    SituFurnishMenuComponent,
    SituFurnishMenuDialogComponent,
  ],
  providers: [
    AuthGuard,
    httpInterceptorProviders,
    MenuItems,
    { provide: RouteReuseStrategy, useClass: ReuseStrategy },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class SharedModule { }
